import { MEDIA_TYPE_MAP } from 'utils/constants'

export const getCurrentResourcesSizeCount = (resourceSizeList = []) => {
  let countInBytes = 0
  resourceSizeList.forEach(mediaFileObj => {
    if (mediaFileObj.type !== MEDIA_TYPE_MAP.image) countInBytes += mediaFileObj.size
  })
  return countInBytes
}

/**
 * Validates whether a choice in a Numeric Rating Scale (NRS) should be labeled
 * based on the total number of choices and the choice index.
 *
 * @param {number} numChoices - Total number of choices in the NRS
 * @param {number} cIndex - Index of the current choice to validate
 * @returns {boolean} True if the choice should be labeled, false otherwise
 */
export const validateNRSChoices = (numChoices, cIndex) => {
  // Always label choices if there are 5 or fewer options
  if (numChoices <= 5) return true

  // Define the labeling patterns for different NRS lengths
  const labelingPatterns = {
    6: [0, 2, 3, 5],
    7: [0, 3, 6],
    8: [0, 2, 5, 7],
    9: [0, 2, 4, 6, 8],
    10: [0, 3, 6, 9],
    11: [0, 3, 5, 7, 10],
  }

  // Check if the current index matches any pattern for the given number of choices
  return labelingPatterns[numChoices]?.includes(cIndex) || false
}
